import React from 'react'
import DashRegWaitSection from '../../components/DashComponents/DashRegWaitSection'

function RegWait() {
  return (
    <div><DashRegWaitSection/></div>
  )
}

export default RegWait